<template>
    <div>
        <table class="text-center"
               :class="[{'leftBorder rightBorder': type !== 'left'},
                        {'leftBorder': type === 'left'}]">
            <tr v-if="!slim" style="height: 64px;"
                class="caption grey--text text--lighten-1">
                <td>Unterschrift</td>
            </tr>
            <tr v-else style="height: 64px; vertical-align: top"
                class="caption grey--text text--lighten-1 text-left">
                <td class="pl-2">
                    Unterschrift
                    <div class="mt-6 text-center signLabel black--text">
                        <slot></slot>
                    </div>
                </td>
            </tr>
            <tr v-if="!slim" class="grey lighten-3 signLabel">
                <td class="pSmall"><slot></slot></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "spiel-bericht-print-sign",
        props: ['type', 'slim'],
    }
</script>

<style scoped>
    table { width: 100%; border-spacing: 0;  border-top: solid 1px grey;
            }/*border-collapse: collapse;*/
    .leftBorder { border-left: solid 1px grey }
    .rightBorder { border-right: solid 1px grey }
    tr, td {border-bottom: solid 1px grey; }
    .signLabel {font-size: 11px}
    .pSmall {padding: 2px 0}
</style>